<app-header></app-header>
<br />
<main class="main-content">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="col-lg-12">
          <div
            class="d-flex align-items-center user-member__title mb-30 mt-30"
            style="padding-top: 20px"
          >
            <h4 class="text-capitalize">
              <!-- Subscription -->
              {{ "subscription_page.title" | translate }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="support-ticket-system support-ticket-system--search">
          <div
            class="userDatatable userDatatable--ticket userDatatable--ticket--2 mt-1"
          >
            <table class="table mb-0 table-borderless">
              <thead>
                <tr class="userDatatable-header">
                  <th>
                    <span class="userDatatable-title text-center">
                      <!-- Reference ID -->
                      {{ "subscription_page.reference_id" | translate }}
                    </span>
                  </th>
                  <th>
                    <span class="userDatatable-title text-center">
                      <!-- Product -->
                      {{ "subscription_page.product" | translate }}
                    </span>
                  </th>
                  <th>
                    <span class="userDatatable-title text-center">
                      <!-- Status -->
                      {{ "subscription_page.status" | translate }}
                    </span>
                  </th>
                  <th>
                    <span class="userDatatable-title text-center">
                      <!-- Renews At -->
                      {{ "subscription_page.renews_at" | translate }}
                    </span>
                  </th>
                  <th>
                    <span class="userDatatable-title text-center">
                      <!-- Actions -->
                      {{ "subscription_page.actions" | translate }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let active_subscription of subscriptions">
                  <td>{{ active_subscription?.gyb_reference }}</td>
                  <td>
                    <div class="d-flex justify-content-center">
                      <div class="userDatatable-inline-title">
                        <a href="javascript:void(0)" class="text-dark fw-500">
                          <h6>{{ active_subscription?.product }}</h6>
                        </a>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="userDatatable-content d-inline-block">
                      <span
                        class="bg-opacity-success color-success userDatatable-content-status active"
                      >
                        <!-- active -->
                        {{ "subscription_page.status_active" | translate }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="userDatatable-content--subject">
                      <!-- {{
                        active_subscription.next_charge_date
                          | date : "mediumDate"
                      }} -->
                      {{
                        getFormattedDate(active_subscription.next_charge_date)
                      }}
                    </div>
                  </td>
                  <td>
                    <div class="dropdown dropdown-btn dropdown-hover">
                      <button
                        class="btn btn-outline-lighten fs-14 fw-400"
                        style="outline: none; border: none"
                      >
                        <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                      </button>
                      <div class="dropdown-default dropdown-bottomCenter">
                        <a
                          *ngIf="
                            active_subscription?.status === 'active';
                            else canceled
                          "
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#modal-info-confirmed"
                          (click)="
                            openModal(
                              $event,
                              active_subscription.subscription_id
                            )
                          "
                        >
                          <!-- Cancel subscription -->
                          {{ "subscription_page.action_cancel" | translate }}
                        </a>
                        <ng-template #canceled>
                          <a class="dropdown-item">
                            <!-- Subscription was canceled -->
                            {{
                              "subscription_page.action_canceled" | translate
                            }}
                          </a>
                        </ng-template>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal-info-confirmed modal fade"
    [ngClass]="{ 'show d-block': isModalOpen }"
    [attr.aria-hidden]="isModalOpen ? 'false' : 'true'"
    id="modal-info-confirmed"
    tabindex="-1"
    role="dialog"
    (click)="handleModalClick($event)"
  >
    <div class="modal-dialog modal-sm modal-info" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="modal-info-body d-flex">
            <div class="modal-info-text">
              <h6>
                <!-- Cancel Subscription? -->
                {{ "subscription_page.modal_title" | translate }}
              </h6>
              <br />
              <p>
                <!-- By cancelling your subscription, you’ll prevent future renewals
                — but don’t worry, we’ll continue monitoring and completing all
                ongoing data deletion requests until your current billing period
                ends. -->
                {{ "subscription_page.modal_text_1" | translate }}
                <br />
                <br />
                <!-- After that, monitoring will stop, and no new deletion requests
                will be sent. -->
                {{ "subscription_page.modal_text_2" | translate }}
                <br />
                <br />
                <!-- Are you sure you want to cancel your subscription? -->
                {{ "subscription_page.modal_text_3" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light btn-outlined btn-sm"
            data-bs-dismiss="modal"
            data-action="confirm"
          >
            <!-- Confirm Cancellation -->
            {{ "subscription_page.modal_confirm_btn" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-info btn-sm"
            data-bs-dismiss="modal"
            data-action="keep"
          >
            <!-- Keep Subscription -->
            {{ "subscription_page.modal_keep_btn" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</main>

<app-footer></app-footer>
